export default "__VITE_ASSET__BDL5SM2h__"